import { use } from 'react';
import { PageTransitionContext, PageTransitionDispatchContext } from './PageTransitionProvider';

/**
 * A custom hook that provides the current loading state of the page transition.
 * @important Be careful when using this hook, it triggers a synchronous re-render on every route change.
 * @returns An `loading` boolean indicating if a page transition is in progress
 */
export const usePageTransition = () => use(PageTransitionContext);

export const usePageTransitionDispatch = () => use(PageTransitionDispatchContext);
